import React from "react";
import { Link } from "react-router-dom";

export const STEPS = [
  { n: "01", t: "Source", d: "We identify specialists with genuine, verifiable domain expertise." },
  { n: "02", t: "Train", d: "We teach them how AI evaluation works — focusing on edge cases, model failure patterns, and strict guidelines." },
  { n: "03", t: "Assess", d: "Practical tasks test their judgment, reasoning, and ability to stay consistent." },
  { n: "04", t: "Vet", d: "Only specialists who clear our benchmarks earn FIAD Vetted status." },
  { n: "05", t: "Connect", d: "Vetted contributors become eligible for relevant AI evaluation projects." },
  { n: "06", t: "Support", d: "We provide hands-on guidance and direct assistance throughout projects so experts are never left to figure things out alone." },
];

export function ProcessSteps({ dark = true }) {
  const line = dark ? "border-white/10" : "border-[#0A0A0A]/12";
  const num = dark ? "text-white/15" : "text-[#0A0A0A]/12";
  const title = dark ? "text-[#F6F3EC]" : "text-[#0A0A0A]";
  const body = dark ? "text-[#A1A1AA]" : "text-[#52525B]";
  return (
    <div className={`relative border-t ${line}`} data-testid="process-steps">
      {/* connecting rail */}
      <span className={`hidden sm:block absolute left-[calc(16.666%-0.5px)] lg:left-[calc(8.333%-0.5px)] top-0 bottom-0 w-px ${dark ? "bg-white/10" : "bg-[#0A0A0A]/10"}`} aria-hidden />
      {STEPS.map((s) => (
        <div key={s.n} className={`relative grid grid-cols-12 gap-4 sm:gap-8 items-baseline border-b ${line} py-8 sm:py-10 group`}>
          <div className="col-span-12 sm:col-span-3 lg:col-span-2 relative">
            <span className={`font-mono-num text-5xl sm:text-6xl lg:text-7xl font-light ${num} transition-colors duration-300 group-hover:text-[#C79447]`}>{s.n}</span>
          </div>
          <h3 className={`col-span-12 sm:col-span-3 lg:col-span-3 font-display text-xl sm:text-2xl font-medium tracking-tight ${title}`}>{s.t}</h3>
          <p className={`col-span-12 sm:col-span-6 lg:col-span-7 text-base leading-relaxed ${body} max-w-xl`}>{s.d}</p>
        </div>
      ))}
    </div>
  );
}

const PILOT_ROUTE = "/pilot";

const FOUNDER_MAIL = "mailto:contact.fiad@gmail.com?subject=FIAD%20Pilot%20%E2%80%94%20AI%20Lab";

export function FounderPilot({ heading = "Let's start with a pilot.", testId = "founder-pilot" }) {
  return (
    <div data-testid={testId}>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.1] text-[#F6F3EC] max-w-2xl">{heading}</h2>
      <div className="mt-8 flex flex-col gap-4">
        <Link data-testid="founder-pilot-cta" to={PILOT_ROUTE} className="inline-flex items-center justify-center gap-2 bg-[#C79447] text-[#0A0A0A] px-7 py-3.5 text-sm font-medium hover:brightness-110 transition-all w-fit">
          Discuss a Pilot
        </Link>
        <span className="inline-flex items-center gap-2 text-sm text-[#A1A1AA]">
          <span className="h-1.5 w-1.5 rounded-full bg-[#C79447]" aria-hidden />
          Direct scoping with our founding team · Response within 24 hours
        </span>
      </div>
    </div>
  );
}
